import { AdditionalWordProps } from '../../types/common'
import { useAppSelector } from '../../utils/agent.store'

const QueueBreadCrumb: React.FC<AdditionalWordProps> = ({
  left = '',
  right = '',
}: AdditionalWordProps) => {
  const selectedQueue = useAppSelector(
    (state) => state.queueCreation.selectedQueue
  )
  return selectedQueue ? left + selectedQueue + right : null
}

export default QueueBreadCrumb
